import { useMutation, useQuery, useQueryClient } from "react-query";
import { AuthorizedService } from "shared/axios";
import { carList } from "utils/constant/queryKey";

const END_POINT = "/brand";

export type Brand = {
  createdAt: string;
  id: string;
  name: string;
  updatedAt: string;
  isDisabled: boolean;
  deletedAt: string | null;
};

export const useBrandList = (includeDisabled = true) => {
  return useQuery<Brand[]>({
    queryKey: carList.list({ includeDisabled }),
    queryFn: async () => {
      const res = await new AuthorizedService().get(
        `${END_POINT}?includeDisabled=${includeDisabled}`
      );
      return res.data;
    },
    refetchOnWindowFocus: true,
  });
};

export const useBrandCreate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { name: string }) => {
      return new AuthorizedService().post(END_POINT, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(carList.all);
    },
  });
};

export const useBrandUpdate = (id: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { isDisabled: boolean }) => {
      return new AuthorizedService().patch(`${END_POINT}/${id}/status`, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(carList.all);
    },
  });
};
